import { useMemo } from 'react';
import * as yup from 'yup';
import { FORM_LINE_TYPES } from 'src/components/ui/FormLine/constants';
import AutocompleteCObjection from 'src/components/ui/Autocomplete/connectors/AutocompleteCObjection';

export const useFormAddObjetion = (params = {}) => {
	const { values } = params;

	const initialValues = useMemo(() => {
		return {
			objection: null,
			comment: '',
			...values,
		};
	}, [values]);

	const shape = useMemo(() => {
		return {
			groups: [
				{
					id: 1,
					lines: [
						{
							id: 1,
							field: {
								type: FORM_LINE_TYPES.custom,
								params: {
									name: 'objection',
									Component: AutocompleteCObjection,
									label: 'Возражение',
								},
							},
						},
						{
							id: 2,
							field: {
								type: FORM_LINE_TYPES.textfield,
								connected: true,
								params: {
									name: 'comment',
									label: 'Комментарий',
									multiline: true,
									minRows: 4,
								},
							},
						},
					],
				},
			],
		};
	}, []);

	const validationSchema = yup.object().shape({
		objection: yup
			.object()
			.required('Выберите возражение')
	});

	return { shape, initialValues, validationSchema };
};

